import { render, staticRenderFns } from "./wk.vue?vue&type=template&id=d9841734&scoped=true"
import script from "./wk.vue?vue&type=script&lang=js"
export * from "./wk.vue?vue&type=script&lang=js"
import style0 from "./wk.vue?vue&type=style&index=0&id=d9841734&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9841734",
  null
  
)

export default component.exports